<script setup lang="ts">
  import { type HTMLAttributes } from 'vue'
  import { cn } from '@gat-ship/vue-components'
  import { useGatForm } from '@gat-ship/vue-components'

  const formContext = useGatForm()

  const props = defineProps<{
    title: string
    optional?: boolean
    class?: HTMLAttributes['class']
    titleClass?: HTMLAttributes['class']
  }>()
</script>
<template>
  <div
    role="separator"
    :class="
      cn(
        'relative flex w-full select-none items-end gap-1 px-5 py-1.5 text-xs text-neutral-500 dark:border-slate-700',
        {
          'bg-neutral-100 dark:bg-neutral-900': !formContext.isProvided
        },
        props.class
      )
    "
    :style="{ letterSpacing: '0.05em' }"
  >
    <span :class="cn('font-medium', props.titleClass)">
      {{ title }}
    </span>
    <span v-if="optional">(optional)</span>
    <slot name="actions" />
  </div>
</template>
